import type { UserWithResolvedScopes } from '../user/user.interface';
import { userFactory } from './user.factory';
import { ObjectFactory } from './object.factory';

export class UserWithResolvedScopesFactory extends ObjectFactory<UserWithResolvedScopes> {
  protected getDefaults(): UserWithResolvedScopes {
    return {
      ...userFactory.build(),
      resolvedScopes: [],
    };
  }
}

export const userWithResolvedScopesFactory = new UserWithResolvedScopesFactory();
